import React from 'react'
import {MANAGE_FEATURE_DESCRIPTION, URL_YUQUE_FEATURES} from '../../../constants/CyHomepage'
import { ManageFeatureCard } from '../components/ManageFeatureCard'
import {diffEndJump} from "../../../utils/tools";


const ManageFeaturePanel: React.FC<{
    isInScreen: boolean
}> = ({
          isInScreen = false
      }) => {

    function clickStat(category, page) {
        // 统计卡片点击流量
        if (window) {
            // 用 stat-portrait
            // @ts-ignore
            window.xqui.useStat({
                action: 'click',
                category: category,
                bizType: 5,
                page: page
            })
        }

        diffEndJump({
            href: URL_YUQUE_FEATURES,
            isOpenNewWindow: true
        })
    }

    return (
        <div className='manage-feature-panel-children'>
            <div className='manage-feature-cards'>
                {
                    MANAGE_FEATURE_DESCRIPTION.map((item, index) => (
                        <div className={`manage-feature-card ${isInScreen ? 'animated fadeInUp' : ''}`}
                             style={{ animationDuration: `${index > 1 ? `${1.5 + index * 0.4}s` : '1s'}` }}
                             onClick={() => clickStat(item.category, item.page)}>

                            <ManageFeatureCard
                                key={index}
                                title={item.title}
                                descriptions={item.descriptions}
                            />
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default ManageFeaturePanel
